// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"376":"ffc91b76","685":"ee476011"}[chunkId] + ".chunk.js";
};